export const stepsTheme = {
  iconSize: 24,
  customIconSize: 24,
  titleLineHeight: 24,
};
